import { Component, OnInit } from '@angular/core';
import packageInfo from '../../../../../../package.json';
import { TranslocoService } from '@jsverse/transloco';

@Component({
    selector: 'jow-footer',
    templateUrl: './footer.component.html',
    styleUrls: ['./footer.component.scss'],
    standalone: false
})
export class FooterComponent implements OnInit {
  public version: string = packageInfo.version;
  public currYear: number;

  constructor(public languageService: TranslocoService) {}

  ngOnInit() {
    this.currYear = new Date().getFullYear();
  }
}
